import {
  exceptFilterKey,
  requestTypeMap,
  cityOptionsMap,
  cityValuesMap,
  CityAndAreaKeyMap
} from './utils'
import VueI18n from '@/i18n/locale'

export default {
  filterValues(state) {
    const currentTab = state.currentTab
    const filterValue = state.filterValue || {}
    const lists = state.lists || {}
    const params = { ...filterValue }

    // --- 特殊逻辑
    params.requestType = requestTypeMap[currentTab]
    params.pageNo = (lists[currentTab] || {}).pageNo || params.pageNo
    // params.pageSize = (lists[currentTab] || {}).pageSize || params.pageSize
    // --- 排除逻辑
    const exceptKey = exceptFilterKey[currentTab] || []
    exceptKey.forEach(key => {
      delete params[key]
    })
    // start --- 城市参数特殊逻辑
    const keys = cityValuesMap[currentTab] || []
    for (let key in params) {
      if (keys.includes(key)) {
        params[CityAndAreaKeyMap[key]] = filterValue[key]
      }
    }
    delete params.AreaCityId
    delete params.AreaAreaIds
    // end --- 城市参数特殊逻辑
    return params
  },
  MoreFilterOption(state) {
    const filterOptions = state.filterOptions || {}
    const selectors = [
      {
        label: VueI18n.t('Internal_Tools_App_vFxG_UzcO'/** 线索状态 */),
        key: 'status',
        col: 2,
        options: filterOptions.status
      },
      {
        label: VueI18n.t('Internal_Tools_App_pynL_unFB' /** 商户类型 */),
        key: 'type',
        col: 3,
        options: filterOptions.type
      }, {
        label: VueI18n.t('Internal_Tools_App_rOKe_yMwP' /** ERP 状态 */),
        key: 'erpStatus',
        col: 3,
        options: filterOptions.erpStatus
      },
      {
        label: VueI18n.t('Internal_Tools_App_zYXv_Uwsb'/** 经营状态 */),
        key: 'bizStatus',
        col: 1,
        options: filterOptions.bizStatus
      }
    ]
    return selectors
  },
  currentListItems(state) {
    const currentTab = state.currentTab
    const lists = state.lists || {}
    return lists[currentTab] || { data: [], total: 0, pageNo: 1, pageSize: 20 }
  },

  citiesOptions(state) {
    const currentTab = state.currentTab
    const filterOptions = state.filterOptions || {}
    return filterOptions[cityOptionsMap[currentTab]]
  }
}
